import { render, staticRenderFns } from "./wiki-preview-demo.vue?vue&type=template&id=1076d20a&"
import script from "./wiki-preview-demo.vue?vue&type=script&lang=ts&"
export * from "./wiki-preview-demo.vue?vue&type=script&lang=ts&"
import style0 from "./wiki-preview-demo.vue?vue&type=style&index=0&id=1076d20a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports